import { env } from 'utils/envManager/envManager'

import { akamaiBreakpoints } from '../Home/constants/akamaiBreakpoints'

export function pointOfInterestImageLoaderFactory(
	pointOfInterest: {
		x: number
		y: number
	},
	heightCalcFunction: (width: number) => number
) {
	return function imageLoader({ src, width }: { src: string; width: number }) {
		const viewportBreakpoint =
			akamaiBreakpoints.find((breakpointWidth) => breakpointWidth >= width) ??
			akamaiBreakpoints[akamaiBreakpoints.length - 1]

		const viewportHeight = Math.ceil(heightCalcFunction(viewportBreakpoint))

		const url = new URL(src, env.NEXT_PUBLIC_SITE_BASE_URL)
		const searchParams = new URLSearchParams({
			imdensity: '1',
		})

		url.search = searchParams.toString()
		url.search = `${url.search}&im=RegionOfInterestCrop,width=${viewportBreakpoint},height=${viewportHeight},regionOfInterest=(${pointOfInterest.x},${pointOfInterest.y})`

		return url.toString()
	}
}
